import $ from 'jquery';
import { getWorkContentFields } from './work-fields';
import {setNotChangedForm} from "./save-work-between-step";
import {showFormResponse} from "../common/json-response";
import {openQuizTab} from "./work-quiz";

function saveWorkQuizFields() {
  const activeStepMenuItem = document.querySelector('.edit-menu__link_active');
  const url  = activeStepMenuItem.parentNode.getAttribute('data-save-draft-url');

  const stepfields = getWorkContentFields();
  stepfields['is_work_quiz_finish'] = true;
  const data = JSON.stringify(stepfields);

  $.ajax({
    type: "POST",
    url: url,
    dataType: 'json',
    data: data,
    success: function (data) {
      if (data.redirectTo?.length) {
        window.location.href = data.redirectTo;
      }

      showFormResponse(data);
    },
    error: function (data) {
      showFormResponse(data);
    },
  });
}

function initSaveWorkByQuizLimit() {
  const workQuizLimitBlock = document.querySelector('#work_quiz_limit_block');

  if (!workQuizLimitBlock) {
    return;
  }

  let fieldsSent = false;
  const quizLimitHours = workQuizLimitBlock.querySelector('[data-name="quiz_params[quiz_limit][hours]"]');
  const quizLimitMinutes = workQuizLimitBlock.querySelector('[data-name="quiz_params[quiz_limit][minutes]"]');

  if (!quizLimitHours || !quizLimitMinutes) {
    return;
  }

  setInterval(function () {
    let newMinutesValue = parseInt(quizLimitMinutes.textContent) - 1;
    newMinutesValue = newMinutesValue >= 0 ? newMinutesValue : 0;
    quizLimitMinutes.innerHTML = newMinutesValue;

    if (newMinutesValue == 0) {
      let quizLimitHoursValue = parseInt(quizLimitHours.textContent);

      if (quizLimitHoursValue > 0) {
        const newHoursValue = quizLimitHoursValue - 1;
        quizLimitHours.innerHTML = newHoursValue >= 0 ? newHoursValue : 0;
        quizLimitMinutes.innerHTML = 59;
      }
    }

    if (!fieldsSent && quizLimitHours.innerHTML == 0 && quizLimitMinutes.innerHTML == 0) {
      fieldsSent = true;
      saveWorkQuizFields();
    }
  }, 60000)
}

export { initSaveWorkByQuizLimit }